// test1627
(1627 && 0);
